package org.ssoft.common.tools

import org.ssoft.common.type.ScreenRatio

fun calculateGCD(a: Int, b: Int): Int {
    var num1 = a
    var num2 = b
    while (num2 != 0) {
        val temp = num2
        num2 = num1 % num2
        num1 = temp
    }
    return num1
}

fun calculateAspectRatio(width: Int, height: Int): Pair<Int, Int> {
    return runCatching {
        if (width == height) return 1 to 1
        if (minOf(width, height).toDouble() / maxOf(width, height).toDouble() > 0.9) return 1 to 1

        val gcd = calculateGCD(width, height)
        val w = width / gcd
        val h = height / gcd
        (maxOf(w, h) to minOf(w, h)).let {
            when (it) {
                8 to 5 -> 16 to 10
                7 to 3 -> 21 to 9
                else -> it
            }
        }
    }.getOrNull() ?: (0 to 0)
}

fun calculateScreenRatio(width: Int, height: Int): ScreenRatio {
    if (width == height) return ScreenRatio._1_1
    if ((minOf(width, height).toDouble() / maxOf(width, height).toDouble()) > 0.9) return ScreenRatio._1_1

    return ScreenRatio.Companion[calculateAspectRatio(width, height)].let {
        if (width > height) it
        else it.reverse()
    }
}